import { AppConfigModel } from "../abstract/app-config.model";

export class VatChargeability extends AppConfigModel {

    static override CLASS_NAME: string = 'VatChargeability';

    /** Option présentée grisée dans les listes déroulantes (mode de calcul non géré). */
    disabled?: boolean;
}
